import { useState, useEffect } from "react";
import { User, X, Menu } from "lucide-react";
import { Link } from "react-router-dom";

const Header = () => {
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("jwt_token");
    setIsAuthenticated(!!token);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY < 50) setShowHeader(true);
      else if (currentScrollY > lastScrollY) setShowHeader(false);
      else setShowHeader(true);
      setLastScrollY(currentScrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const handleMouseEnter = () => setIsSubMenuOpen(true);
  const handleMouseLeave = () => setIsSubMenuOpen(false);

  const AuthSection = () =>
    isAuthenticated ? (
      <Link to="/user-dashboard" className="text-black hover:text-[#94c41c] text-2xl">
        <User className="w-8 h-8" />
      </Link>
    ) : (
      <div className="flex space-x-4 items-center">
        <Link
          to="/login"
          className="text-black hover:underline hover:text-[#94c41c] lg:text-xl xl:text-xl transition"  // più piccolo
        >
          Login
        </Link>
        <Link
          to="/register"
          className="bg-[#94c41c] text-white px-6 py-2 rounded-md hover:bg-black lg:text-xl xl:text-xl transition" // più piccolo
        >
          Registrazione
        </Link>
      </div>
    );

  return (
    <header
      className={`bg-[#fbfef5] sticky top-0 z-50 transition-transform duration-300 ${showHeader ? "translate-y-0" : "-translate-y-full"}`}
    >
      {/* Desktop (1300px+) */}
      <div className="container mx-auto flex items-center justify-between px-8 py-6 max-w-[85%] hidden xl:flex">
        <Link to="/">
          <img src="/static/logo-seeurl.svg" alt="Logo" className="h-12 w-auto" />
        </Link>

        <nav className="flex space-x-12 text-xl pl-40">
          <Link
            to="/view-domains"
            className="text-black hover:text-[#94c41c] transition"
          >
            Domini
          </Link>
          <Link
            to="/chi-siamo"
            className="text-black hover:text-[#94c41c] transition"
          >
            Chi Siamo
          </Link>
          <Link
            to="/contatti"
            className="text-black hover:text-[#94c41c] transition"
          >
            Contatti
          </Link>
          <Link
            to="/faq"
            className="text-black hover:text-[#94c41c] transition"
          >
            FAQ
          </Link>
        </nav>

        <div className="flex space-x-8 items-center">
          <AuthSection />
        </div>
      </div>

      {/* Tablet (1300px - 900px) */}
      <div className="container mx-auto flex items-center justify-between px-8 py-6 max-w-[90%] hidden lg:flex xl:hidden">
        <Link to="/">
          <img src="/static/logo-seeurl.svg" alt="Logo" className="h-10 w-auto" /> {/* logo più piccolo */}
        </Link>

        <nav className="flex space-x-8 text-xl">
          <Link
            to="/view-domains"
            className="text-black hover:text-[#94c41c] transition"
          >
            Domini
          </Link>
          <Link
            to="/chi-siamo"
            className="text-black hover:text-[#94c41c] transition"
          >
            Chi Siamo
          </Link>
          <Link
            to="/contatti"
            className="text-black hover:text-[#94c41c] transition"
          >
            Contatti
          </Link>
          <Link
            to="/faq"
            className="text-black hover:text-[#94c41c] transition"
          >
            FAQ
          </Link>
        </nav>

        <div className="flex space-x-8 items-center">
          <AuthSection />
        </div>
      </div>

      {/* Mobile (900px-) */}
      <div className="container mx-auto flex items-center justify-between px-5 py-6 max-w-[100%] lg:hidden relative">
        <Link to="/">
          <img src="/static/logo-seeurl.svg" alt="Logo" className="h-8" />
        </Link>

        <button
          aria-label={menuOpen ? "Chiudi menu" : "Apri menu"}
          onClick={() => setMenuOpen((prev) => !prev)}
          className="text-black absolute right-0 top-[50%] -translate-y-1/2 px-8 text-xl focus:outline-none"
        >
          {menuOpen ? <X size={32} /> : <Menu size={32} />}
        </button>

        {/* Menu dropdown full width sotto header */}
        {menuOpen && (
          <div className="absolute top-full left-0 w-full bg-[#fbfef5] space-y-6 py-2 px-8 z-50 text-xl">
            <Link
              to="/view-domains"
              className="block text-black hover:text-[#94c41c] transition"
              onClick={() => setMenuOpen(false)}
            >
              Domini
            </Link>
            <Link
              to="/chi-siamo"
              className="block text-black hover:text-[#94c41c] transition"
              onClick={() => setMenuOpen(false)}
            >
              Chi Siamo
            </Link>
            <Link
              to="/contatti"
              className="block text-black hover:text-[#94c41c] transition"
              onClick={() => setMenuOpen(false)}
            >
              Contatti
            </Link>
            <Link
              to="/faq"
              className="block text-black hover:text-[#94c41c] transition"
              onClick={() => setMenuOpen(false)}
            >
              FAQ
            </Link>
            {!isAuthenticated ? (
              <>
                <Link
                  to="/login"
                  className="block text-black sottolineatura-link hover:text-[#94c41c] text-xl transition"
                  onClick={() => setMenuOpen(false)}
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="block text-[#95c11f] sottolineatura-link text-xl transition hover:text-black"
                  onClick={() => setMenuOpen(false)}
                >
                  Registrazione
                </Link>
              </>
            ) : (
              <Link
                to="/user-dashboard"
                className="block text-black sottolineatura-link hover:text-[#94c41c] transition"
                onClick={() => setMenuOpen(false)}
              >
                Gestione account
              </Link>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
